import React, {useCallback, useEffect, useRef, useState} from "react"

import {Select} from "@ciq/shared/components/select"

import {ReactComponent as CheckIcon} from "@ciq/shared/assets/icons/item_selected_icon.svg"
import {SchoolIcon} from "./icons/school"
import {useAppContext} from "@ciq/shared/hooks/context"

export const SchoolDropdown = () => {
  const {school, schools, setSchool} = useAppContext()
  const formatter = (s) => ({label: s.name, value: s, isCurrent: school.id === s.id})

  const handleOnChange = useCallback((newValue) => {
    setSchool(newValue.value)
  }, [setSchool])

  if (!school || !schools?.length) return null

  return (
    <div className="da-navbar-school">
      <SchoolIcon school={school}/>
      <Select
        value={school ? formatter(school) : ""}
        options={schools.map(formatter)}
        components={{Option: SchoolOption}}
        onChange={handleOnChange}
        isSearchable={true}
      />
    </div>
  )
}

const DEFAULT_CLASSNAME = "da-navbar-school-option da-select__option"
const HOVER_CLASSNAME = "da-select__option--is-focused"

const SchoolOption = ({...props}) => {
  const [classNames, setClassNames] = useState([DEFAULT_CLASSNAME])
  const divRef = useRef(null)


  useEffect(() => {
    const div = divRef.current

    if (div == null) {
      return
    }

    const setMouseOver = () => setClassNames([DEFAULT_CLASSNAME, HOVER_CLASSNAME])
    const setMouseLeave = () => setClassNames([DEFAULT_CLASSNAME])

    div.addEventListener("mouseover", setMouseOver, {passive: true})
    div.addEventListener("mouseleave", setMouseLeave, {passive: true})

    return () => {
      div.removeEventListener("mouseover", setMouseOver, {passive: true})
      div.removeEventListener("mouseleave", setMouseLeave, {passive: true})
    }
  }, [])

  const handleOnClick = () => {
    props.setValue(props.data)
  }

  return (
    <div ref={divRef} className={classNames.join(" ")} onClick={handleOnClick}>
      <SchoolIcon school={props.data.value}/>
      <span>{props.data.label}</span>
      {!!props.data.isCurrent && <CheckIcon style={{marginLeft: "auto"}}/>}
    </div>
  )
}
